export const heroData = {
  title: "51每日大赛",
  subtitle: "24小时不打烊爆料站",
  description: "素人网红翻车现场 · 娱乐圈不雅内幕 · 全网反差视频精选入口。资深吃瓜群众的深夜专属基地，带你第一时间看遍全网大瓜。",
  ctaText: "点击直达最新爆料",
};

export const featureCards = [
  {
    id: "feature-1",
    title: "网红翻车现场",
    tag: "热门追踪",
    description: "素人网红人设崩塌全记录，从爆红到翻车只在一瞬间",
    image: "https://readdy.ai/api/search-image?query=Dark%20dramatic%20studio%20scene%20with%20a%20shattered%20smartphone%20on%20dark%20surface%2C%20cracked%20screen%2C%20dramatic%20lighting%20with%20warm%20orange%20and%20deep%20shadow%2C%20cinematic%20noir%20atmosphere%2C%20editorial%20photography%20style%2C%20high%20contrast%2C%20textured%20dark%20backdrop%2C%20mysterious%20and%20intense%20mood&width=800&height=1000&seq=home-feature-card-01&orientation=portrait",
    color: "primary",
    size: "large",
  },
  {
    id: "feature-2",
    title: "反差视频精选",
    tag: "每日更新",
    description: "台前幕后巨大反差，表面光鲜亮丽背后不为人知的真实面目",
    image: "https://readdy.ai/api/search-image?query=Split%20screen%20concept%20with%20contrasting%20scenes%2C%20left%20side%20bright%20glamorous%20red%20carpet%20with%20camera%20flashes%2C%20right%20side%20dark%20shadowy%20backstage%20with%20dim%20lighting%2C%20cinematic%20composition%2C%20dramatic%20mood%2C%20teal%20and%20warm%20tone%20contrast%2C%20editorial%20style&width=800&height=500&seq=home-feature-card-02&orientation=landscape",
    color: "accent",
    size: "small",
  },
  {
    id: "feature-3",
    title: "酒店猛料曝光",
    tag: "独家内幕",
    description: "娱乐圈不为人知的酒店密会与行业内幕，每日震撼更新",
    image: "https://readdy.ai/api/search-image?query=Luxury%20hotel%20corridor%20at%20night%20with%20dim%20warm%20lighting%2C%20slightly%20open%20door%20casting%20light%20into%20dark%20hallway%2C%20mysterious%20atmosphere%2C%20noir%20cinematic%20style%2C%20deep%20shadows%2C%20amber%20and%20rose%20gold%20tones%2C%20suspenseful%20mood%2C%20editorial%20photography%20with%20film%20grain&width=800&height=500&seq=home-feature-card-03&orientation=landscape",
    color: "secondary",
    size: "small",
  },
];

export const trackingCards = [
  {
    id: "track-1",
    title: "知名带货主播直播间翻车，背后资本运作曝光",
    category: "网红翻车",
    time: "2小时前",
    image: "https://readdy.ai/api/search-image?query=Dark%20studio%20with%20a%20single%20spotlight%20on%20an%20empty%20live%20streaming%20setup%2C%20ring%20light%20turned%20off%2C%20microphone%20on%20desk%2C%20dramatic%20shadows%2C%20minimalist%20dark%20background%2C%20cinematic%20lighting%2C%20mysterious%20atmosphere%2C%20warm%20accent%20light%20from%20one%20side&width=600&height=600&seq=home-track-card-01&orientation=squarish",
  },
  {
    id: "track-2",
    title: "豪门恋情大反转，酒店密会视频流出引争议",
    category: "酒店猛料",
    time: "5小时前",
    image: "https://readdy.ai/api/search-image?query=Elegant%20hotel%20suite%20with%20curtains%20partially%20drawn%2C%20city%20lights%20visible%20through%20window%2C%20dim%20ambient%20lighting%2C%20empty%20armchair%20and%20side%20table%20with%20wine%20glass%2C%20mysterious%20romantic%20atmosphere%2C%20film%20noir%20style%2C%20deep%20shadows%2C%20warm%20and%20cool%20tone%20contrast&width=600&height=600&seq=home-track-card-02&orientation=squarish",
  },
  {
    id: "track-3",
    title: "素人网红人设崩塌，私生活混乱证据被扒",
    category: "反差视频",
    time: "8小时前",
    image: "https://readdy.ai/api/search-image?query=Broken%20mirror%20reflecting%20fragmented%20faces%2C%20dark%20room%20with%20scattered%20photos%20on%20floor%2C%20dramatic%20side%20lighting%2C%20conceptual%20art%20style%2C%20warm%20amber%20light%20from%20table%20lamp%2C%20chaotic%20elegance%2C%20editorial%20photography&width=600&height=600&seq=home-track-card-03&orientation=squarish",
  },
  {
    id: "track-4",
    title: "娱乐圈大佬私下聚会照曝光，关系网错综复杂",
    category: "独家内幕",
    time: "12小时前",
    image: "https://readdy.ai/api/search-image?query=Dark%20private%20dining%20room%20with%20long%20empty%20table%2C%20half-finished%20wine%20glasses%2C%20dim%20chandelier%20light%2C%20luxurious%20but%20abandoned%20setting%2C%20mysterious%20atmosphere%2C%20noir%20cinematic%20style%2C%20deep%20shadows%2C%20warm%20golden%20light%20from%20above&width=600&height=600&seq=home-track-card-04&orientation=squarish",
  },
  {
    id: "track-5",
    title: "顶流明星机场被拍，与神秘女子同行引发猜测",
    category: "网红翻车",
    time: "16小时前",
    image: "https://readdy.ai/api/search-image?query=Empty%20airport%20terminal%20at%20night%2C%20long%20corridor%20with%20dim%20overhead%20lights%2C%20reflection%20on%20polished%20floor%2C%20solitary%20luggage%20cart%2C%20atmospheric%20and%20mysterious%2C%20cinematic%20composition%2C%20cool%20and%20warm%20tone%20blend&width=600&height=600&seq=home-track-card-05&orientation=squarish",
  },
];

export const reviewData = {
  tag: "吃瓜现场",
  title: "网友热评精选",
  titleHighlight: "真实爆料第一线",
  reviews: [
    {
      quote: "这个网站真的太敢爆了！之前看到某网红的翻车全过程，比微博热搜还快好几个小时，我直接安利给了整个部门同事，现在大家都在蹲每日更新。",
      author: "吃瓜不嫌事大",
      avatar: "https://readdy.ai/api/search-image?query=Minimalist%20portrait%20silhouette%20on%20solid%20light%20blue%20background%2C%20side%20profile%2C%20anonymous%20mysterious%20style%2C%20clean%20modern%20aesthetic%2C%20soft%20lighting%2C%20editorial%20portrait%20photography&width=400&height=400&seq=home-review-avatar-01&orientation=squarish",
    },
    {
      quote: "作为资深吃瓜人，51每日大赛是我每天必刷的网站。爆料速度快、内容劲爆、从不藏着掖着，深夜里打开就是一顿狂吃，根本停不下来！",
      author: "深夜不关机",
      avatar: "https://readdy.ai/api/search-image?query=Minimalist%20portrait%20silhouette%20on%20solid%20warm%20coral%20background%2C%20side%20profile%2C%20anonymous%20mysterious%20style%2C%20clean%20modern%20aesthetic%2C%20soft%20lighting%2C%20editorial%20portrait%20photography&width=400&height=400&seq=home-review-avatar-02&orientation=squarish",
    },
    {
      quote: "反差视频那个栏目简直是宝藏！看到那些平时光鲜亮丽的网红背后真实的样子，反差大到让人惊掉下巴。每天不刷一遍都睡不着觉。",
      author: "吃瓜第一线记者",
      avatar: "https://readdy.ai/api/search-image?query=Minimalist%20portrait%20silhouette%20on%20solid%20teal%20background%2C%20side%20profile%2C%20anonymous%20mysterious%20style%2C%20clean%20modern%20aesthetic%2C%20soft%20lighting%2C%20editorial%20portrait%20photography&width=400&height=400&seq=home-review-avatar-03&orientation=squarish",
    },
  ],
};